/* Fix menu on scroll */

//use window.scrollY
let scrollpos = window.scrollY;
let fixedMenu = document.getElementById("shopify-section-template--19261138796675__floating_menu_p3BDYb");

// let fixedMenu2 = document.getElementById("shopify-section-template--17539014393987__floating_menu_p3BDYb");
let fixedMenu2 = document.querySelector(".section-floating-menu");

function changeHead(){
  let menuHead = document.querySelector('.floating-menu-btn .menu-header');
    menuHead.innerHTML = "Menu";
}

function add_class_on_scroll(fmenu) {
  console.log("Scrolled")
    fmenu.classList.add("fixmenu");
}

function remove_class_on_scroll(fmenu) {
    fmenu.classList.remove("fixmenu");
}

window.addEventListener('scroll', function(){ 
    //Here you forgot to update the value
    scrollpos = window.scrollY;
    
    if(scrollpos > 400){
        add_class_on_scroll(fixedMenu2);
        add_class_on_scroll(fixedMenu);
    }
    else {
        remove_class_on_scroll(fixedMenu2);
        remove_class_on_scroll(fixedMenu);
        changeHead();
    }
    console.log(scrollpos);
});

const listItems = document.querySelectorAll('.top-level');
const subListItems = document.querySelectorAll('.sub-menu > .inner>li');

listItems.forEach(listItem => {
  listItem.addEventListener('click', () => {
    // Do something when the list item is clicked
    const subMenu = listItem.nextElementSibling;
    subMenu.classList.toggle("open");
    listItem.classList.toggle("sub-open");
    if(listItem.classList.contains("sub-open")){
      listItem.children[1].innerHTML="_";  
    }else{
      listItem.children[1].innerHTML="+";
    }
    
   
  });
});

subListItems.forEach(sublistItem =>{
    sublistItem.addEventListener('click',()=>{
      let menuHead = document.querySelector('.floating-menu-btn .menu-header');
      const floatingMenu = document.querySelector(".floating-menu");
      floatingMenu.classList.remove("is-open");
      menuHead.innerHTML = sublistItem.innerHTML;
      subListItems.forEach(subItem =>{
        subItem.classList.remove('active')
      })
      sublistItem.classList.add('active');
      
      
    })
});



// const floatingMenu = document.querySelector(".floating-menu");
//   floatingMenu.classList.toggle("is-open");

const floatingMenuBtn = document.querySelector('.floating-menu-btn');

floatingMenuBtn.addEventListener('click',()=>{
  const floatingMenu = document.querySelector(".floating-menu");
  floatingMenu.classList.toggle("is-open");
})